<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'PRINT|Ustawienia drukowania' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">
        <h2>{{ 'PRINT|Drukuj' | translate }}</h2>
        <div class="print-types">
            <icc-radio
                id="print-type-standard"
                name="print-type"
                [value]="'standard'"
                [(ngModel)]="type"
            >
                {{ 'PRINT|Standardowy' | translate }}
            </icc-radio>

            <icc-radio
                id="print-type-templated"
                name="print-type"
                [value]="'templated'"
                [(ngModel)]="type"
            >
                {{ 'PRINT|Z szablonu' | translate }}
            </icc-radio>
        </div>
        <h2 *ngIf="data.selectBuyDocument && type === 'templated'" iccLabel>{{ 'PRINT|Wybierz dokument' | translate }}</h2>
        <div class="document-select" *ngIf="type === 'templated'">
            <icc-select
                [ngModel]="selectedDocumentId"
                (ngModelChange)="onDocumentChange($event)"
                *ngIf="data.selectBuyDocument"
            >
                <option *ngFor="let document of data.buyDocuments" [value]="document.uuid"><ng-container [ngSwitch]="document?.salesDocumentTypeId">
                    <ng-container *ngSwitchCase="1" >{{ 'SALES_DOCUMENT|Oferta' | translate }}</ng-container>
                    <ng-container *ngSwitchCase="2" >{{ 'SALES_DOCUMENT|Zapytanie ofertowe' | translate }}</ng-container>
                    <ng-container *ngSwitchCase="3" >{{ 'SALES_DOCUMENT|Zamówienie' | translate }}</ng-container>
                    <ng-container *ngSwitchCase="5" >{{ 'SALES_DOCUMENT|Zamówienie serwisowe' | translate }}</ng-container>
                </ng-container> - {{ data.sellerCompanyName }} - {{data.departments[document.sellerProductDepartmentId]}}</option>
            </icc-select>
        </div>
        <h2 *ngIf="type === 'templated'">{{ 'PRINT|Wybierz szablon' | translate }}</h2>
        <p class="description" *ngIf="type === 'templated' && !divisions.length && !printTemplates.length">{{ 'INTERFACE|Trwa ładowanie ustawień...' | translate }}</p>
        <div class="division-select" *ngIf="type === 'templated'">
            <label iccLabel>{{ 'PRINT|Szablon dokumentu' | translate }}</label>
            <icc-select
                [ngModel]="selectedMainTemplateId"
                (ngModelChange)="onMainTemplateChange($event)"
            >
                <option *ngFor="let template of printTemplates; trackBy: trackById" [value]="''+template.id">{{ template.name }}</option>
            </icc-select>
        </div>
        <div class="description" *ngIf="type === 'templated' && selectedMainTemplate?.description" [innerHTML]="selectedMainTemplate?.description | html"></div>
        <ng-container *ngIf="type === 'templated' && divisions?.length && selectedMainTemplate?.hasPositionList">
            <h3>{{ 'PRINT|Szablony pozycji' | translate }}</h3>
            <div *ngFor="let division of divisions" class="division-select">
                <label iccLabel>
                    <span *ngIf="division.kind === 'category'">{{ 'PRODUCT|Kategoria produktów' | translate }}</span>
                    <span *ngIf="division.kind === 'department'">{{ 'PRODUCT|Dział' | translate }}</span>
                    <span *ngIf="division.kind === 'configurator'">{{ 'CONFIGURATOR|Konfigurator' | translate }}</span>
                    {{ division.name }}
                </label>
                <icc-select
                    [(ngModel)]="selectedTemplatesIds[division.kind + '-' + division.id]"
                    (ngModelChange)="onDivisionTemplateChange(division, $event)"
                >
                    <option *ngFor="let template of division.templates; trackBy: trackById" [value]="template.id">{{ template.name }}</option>
                </icc-select>
            </div>
        </ng-container>
        <h3 *ngIf="type === 'templated' && selectedMainTemplate && (selectedMainTemplate.hasSummary || showSketchesSettings || showMontageSchemasSettings || data.hasAttachments)">{{ 'PRINT|Ustawienia' | translate }}</h3>
        <div class="print-settings" *ngIf="type === 'templated' && selectedMainTemplate && (selectedMainTemplate.hasSummary || showSketchesSettings || showMontageSchemasSettings || data.hasAttachments)">
            <label iccLabel>{{ 'PRINT|Drukuj:' | translate }}</label>
            <icc-checkbox [(ngModel)]="printSettings.printSummary" *ngIf="selectedMainTemplate?.hasSummary">{{ 'PRINT|Podsumowanie dokumentu' | translate }}</icc-checkbox>
            <icc-checkbox [(ngModel)]="printSettings.printSketches" *ngIf="showSketchesSettings">{{ 'PRINT|Szkice' | translate }}</icc-checkbox>
            <icc-checkbox [(ngModel)]="printSettings.printMontageSchemas" *ngIf="showMontageSchemasSettings">{{ 'PRINT|Schematy montażu' | translate }}</icc-checkbox>
            <icc-checkbox [(ngModel)]="printSettings.printAttachments" *ngIf="data.hasAttachments">{{ 'PRINT|Załączniki (tylko w formacie PDF, JPG, PNG, WEBP)' | translate }}</icc-checkbox>
        </div>
    </div>

    <div class="dialog-footer flex-vertical">
        <div class="flex-horizontal w-100">
            <button iccButton (click)="close()">{{ 'INTERFACE|Anuluj' | translate}}</button>
            <button iccButton (click)="print()" *ngIf="data.mode === 'print'">{{ 'PRINT|Drukuj' | translate}}</button>
            <button iccButton (click)="print()" *ngIf="data.mode === 'download'">{{ 'PRINT|Pobierz PDF' | translate}}</button>
        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
